import { API_PREFIX } from "./api.constants";

export const UPLOAD_ENDPOINTS = {
  UPLOAD_FILE: `${API_PREFIX}/uploads/file`,
  GET_FILE: (fileId: number | string) => `${API_PREFIX}/uploads/file/${fileId}`,
  DELETE_FILE: (fileId: number | string) => `${API_PREFIX}/uploads/file/${fileId}`,
};